import { PublicAdministration } from './../../../../models/publicAdministration.model';
import { LookupService } from './../../../../services/lookup.service';
import { LookupDTO } from './../../../../models/lookup.model';
import { Component, OnInit, ChangeDetectorRef, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomerDTO } from '../../../../models/customer.model';
import { CustomerService } from '../../../../services/customer.service';
import { DialogService } from '../../../../services/dialog.service';
import { GlobalService } from '../../../../services/global.service';
import { UniversalValidators } from 'ngx-validators';
import { UtilityService } from '../../../../services/utility.service';
import { EnterprisesSearchComponent } from '../enterprises-search/enterprises-search.component';
import { Console } from 'console';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StableOrganisationDTO } from '../../../../models/stableOrganisation.model';
import { StableOrganisationService } from '../../../../services/stableOrganisation.service';
import { ConfigColumn, EqpTableComponent, TypeColumn } from '@eqproject/eqp-table';

@Component({
  selector: 'app-add-customers',
  templateUrl: './add-customers.component.html',
  styleUrls: ['./add-customers.component.scss']
})
export class AddCustomersComponent implements OnInit {

  DisableRedirectAfterSave: boolean = false;
  idLookupEntity: number = null;
  ExternalType: string;
  globalService = GlobalService;

  customerForm: UntypedFormGroup;
  customer: CustomerDTO = new CustomerDTO();
  title: string = '';
  retriviedPublicAdministrations: Array<LookupDTO> = new Array<LookupDTO>();
  utilityService = UtilityService;
  paModel: any;

  type: string;
  TipoSoggetto: number;
  isPrivato: boolean = false;
      
  
  @ViewChild("establishmentTemplate", { static: true }) establishmentTemplate: TemplateRef<any>  
  @ViewChild('establishmentAddress', { static: true }) establishmentAddress: TemplateRef<any>;
  establishmentTemplateRef: MatDialogRef<TemplateRef<any>>;
  establishmentLineTitle: string = this.translate.instant("GENERIC_LABEL.ADD_STABLE_ORGANISATION");  
  establishmentLineForm: UntypedFormGroup;
  establishmentLine: StableOrganisationDTO = new StableOrganisationDTO();
  
  tempestablishmentLines: Array<StableOrganisationDTO> = new Array<StableOrganisationDTO>();
  editLineIndex: number = null;
  

  @ViewChild("establishmentLinesTable", { static: false }) establishmentLinesTable: EqpTableComponent;
  columns: Array<ConfigColumn>;
  
  constructor(
    public translate: TranslateService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private activateRoute: ActivatedRoute,
    private customerService: CustomerService,
    private cd: ChangeDetectorRef,
    private lookupService: LookupService,
    private stableOrganisationService: StableOrganisationService,
    private dialog: MatDialog,) {
  }

  ngOnInit(): void {
    // Assegno a type il valore della rotta - C o F
    this.type = this.ExternalType != null ? this.ExternalType : this.activateRoute.snapshot.params["type"];
        
    this.configureColumns();

    let currentID = this.idLookupEntity == 0 ? null : this.idLookupEntity != null ? this.idLookupEntity : Number(this.activateRoute.snapshot.params["id"] != null) ? Number(this.activateRoute.snapshot.params["id"]) : null;

    // L'ID è presente, entro in modifica ricostruendo i dati dell'utente
    if (currentID != null) {

      this.title = this.translate.instant("GENERIC_LABEL.EDIT");

      this.customerService.getCustomerByID(currentID)
        .then((res) => {
          this.customer = res;
          this.type = this.customer.Type;
          this.customerTypeSelected(this.customer.CustomerType);
          this.createForm();     
          
          this.stableOrganisationService.getListByCustomerID(currentID).subscribe({
            next: res => this.tempestablishmentLines = res,    
          });
        })
        .catch((err) => {
          DialogService.Error(err.message);
        });
    }
    else {
      // L'ID non è presente, entro in aggiunta
      this.title = this.translate.instant("GENERIC_LABEL.ADD");
      this.customer = new CustomerDTO();

      //Di default, il type se non passato sarà di tipo Customer
      if (this.type == null)
        this.type = "C";

      // Di default se il type è C allora abilito l'addebito del bollo
      if (this.type == "C") {
        this.customer.AddebitaBollo = true;    
      }

      // Assegno a Type il valore C o F
      this.customer.Type = this.type;
      // Azienda corrente
      this.customer.FK_Company = GlobalService.getUsedCompany();
      this.createForm();
    }

    this.TipoSoggetto = this.globalService.companyDashboardStaticObject.TipoSoggetto;        
    
    
    //this.getPAList();
  }

  validateIntraVatnumber() {
    let vatNumber = "";

    if (this.customer.FR_TVA !=null)  vatNumber += this.customer.FR_TVA ;
    
    if (this.customer.FR_Siren!=null) vatNumber += this.customer.FR_Siren;

    this.customer.VatNumber=vatNumber
  }    


  /**
   * Creazione del form dati
   **/
  createForm() {
    

    this.customerForm = this.formBuilder.group({
      denomination: [this.customer.Denomination, null],
      paModel: [this.paModel, null],      
      vatNumber: [this.customer.VatNumber, Validators.compose([            
        UniversalValidators.minLength(9),
        UniversalValidators.maxLength(9)
      ])],
      siren: [this.customer.FR_Siren, null],      
      nic: [this.customer.FR_Nic, Validators.compose([
        UniversalValidators.minLength(5),
        UniversalValidators.maxLength(5)
      ])],
      tva: [this.customer.FR_TVA, null],
      FR_CountrySubentity : [this.customer.FR_CountrySubentity, null],
      telephone: [this.customer.Telephone, null],
      mobile: [this.customer.Mobile, null],
      complement: [this.customer.FR_ComplementAddress, null],
      street: [this.customer.Street, Validators.required],
      IBAN: [this.customer.IBAN, null],
      email: [this.customer.Email, null],
      webSite: [this.customer.WebSite, null],
      fiscalCode: [this.customer.FiscalCode, null],
      city: [this.customer.City, Validators.required],
      district: [this.customer.District, null],
      postalCode: [this.customer.PostalCode, Validators.required],
      //codDestFE: [this.customer.CodDestFE, Validators.required],
      pecDestFE: [this.customer.PecDestFE, null],
      rifAmmFE: [this.customer.RifAmmFE, null],
      country: [this.customer.Country, null],
      streetNumber: [this.customer.StreetNumber, null],
      split: [this.customer.Split, null],
      addebitabollo: [this.customer.AddebitaBollo, null],
      FlagOpposizioneSTS: [this.customer.FlagOpposizioneSTS, null],
      name: [this.customer.Name, null],
      surname: [this.customer.Surname, null],
      isPA: [this.customer.IsPA, null],
      paymentType: [this.customer.PaymentType, null],
      paymentCondition: [this.customer.PaymentCondition, null],
      documentCausal: [this.customer.DocumentCausal, null],
      customerType: [this.customer.CustomerType, null],
      nation: [this.customer.Nation, Validators.required],
      isCarrier: [this.customer.IsCarrier],
      carrierTitle: [this.customer.CarrierTitle],
      carrierEoriCode: [this.customer.CarrierEORICode],
      drivingLicense: [this.customer.CarrierDrivingLicenseNumber],
      eoriCode: [this.customer.EoriCode, Validators.compose([
        UniversalValidators.minLength(13)
      ])],
      title: [this.customer.Title, Validators.compose([
        UniversalValidators.minLength(2)
      ])]
    });

    //Se il type è Customer allora il codice destinatario è obbligatorio, se fornitore no
    // if (this.type == "F")
    //   this.customerForm.controls["codDestFE"].setValidators(null);
    

  }

  async getPAList() {
    this.retriviedPublicAdministrations = await this.customerService.getAllPublicAdministrations();
  }

  onToggleChange(): void {
    this.customer.FlagOpposizioneSTS = this.customer.IsPA ? false : this.customer.FlagOpposizioneSTS;
    this.customer.AddebitaBollo = this.customer.IsPA ? false : this.customer.AddebitaBollo;
  }

  customerTypeSelected(event) {    
    
    this.isPrivato =  (event != null && event.FullObject != null && event.FullObject.Code == 'P' );
    if (!this.isPrivato) 
      this.customer.FlagOpposizioneSTS = false;
  }

  /**
   * Salvataggio dei dati
   **/
  save() {
    //Controllo il form
    if (this.customerForm != null && this.customerForm.invalid == true) {
      this.customerForm.markAllAsTouched();
      // Force change detection to ensure all components update their validation state immediately
      this.cd.detectChanges();
      return;
    }



    let dataErrors = this.checkDataValidation();

    if (dataErrors != null && dataErrors.length > 0) {
      DialogService.Error(dataErrors);
      return;
    }

    this.customer.FR_Siren = this.customer.VatNumber;

    this.customerService.checkExistingVatNumberFiscalCode(this.customer).then((res) => {

      if (res != null) {
        DialogService.Confirm(res, () => {
          this.saveConfirmed();
        }, true);
      }
      else
        this.saveConfirmed();

    }).catch((err) => {
      DialogService.Error(err.message);
    });

  }

  saveConfirmed() {
    this.customerService.saveCustomer(this.customer)
      .then((res) => {
        
        if (this.tempestablishmentLines != null && this.tempestablishmentLines.length > 0) {
          this.tempestablishmentLines.forEach(el => {
            el.FK_Customer = res;
            this.stableOrganisationService.save(el).then(res => {        
          })
          })
        }                  

        if (this.DisableRedirectAfterSave == false) {
          DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"));
          this.exit();
        } else if (this.lookupService.lookupAddingComplete != undefined) {
          this.lookupService.lookupAddingComplete.emit(res);
        }
      })
      .catch((err) => {
        DialogService.Error(err.message);
      })
  }

  /**
   * Annulla l'operazione di aggiunta
   **/
  exit() {
    if (this.DisableRedirectAfterSave == false) {
      this.router.navigate(['/registry/list-customers/', this.type]);
    } else if (this.lookupService.lookupAddingComplete != undefined) {
      this.lookupService.lookupAddingComplete.emit(null);
    }
  }

  /**
   * Al change della Ricerca PA, popolo automaticamente i dati nella form
   * @param event PublicAdministration
   */
  paSelected(event) {

    if (event == null)
      return;

    this.customerService.getPublicAdministration(event.ID).then((res) => {
      this.customer = new CustomerDTO();
      this.customer.Denomination = res.Description;
      this.customer.FiscalCode = res.Cf;
      this.customer.City = res.Municipality;
      this.customer.District = res.District;
      this.customer.PostalCode = res.PostalCode;
      this.customer.CodDestFE = res.CodeUniOu;
      this.customer.Street = res.Address;
      this.customer.PecDestFE = res.Mail1;
      this.customer.WebSite = res.InsitutionalSite;
      this.customer.Split = true;
      this.customer.AddebitaBollo = false;
      this.customer.FlagOpposizioneSTS=false;
      this.customer.IsPA = true;
      this.customer.Type = this.type;
      this.customer.FK_Company = GlobalService.getUsedCompany();

      //Assegno la nazione Italia di default
      let italyNation = new LookupDTO();
      italyNation.ID = "IT";
      italyNation.Label = "Italia";
      this.customer.Nation = italyNation;

      this.cd.detectChanges();

    }).catch((err) => {
      DialogService.Error(err.message)
    })


  }

  //Se l'entità è di tipo Cliente, allora abilito l'automatismo per cui alla selezione di una nazione
  //differente dall'italia imposto in automatico delle costanti nell'anagrafica
  nationSelected(nation: LookupDTO) {
    // if (nation.ID != "IT" && this.type == 'C') {
    //   this.customer.District = "EE";
    //   this.customer.CodDestFE = "XXXXXXX";
    //   this.customer.PostalCode = "00000";
    // }
  }
  
  onEnterpriseSelected(item: any) {
    this.customer.Denomination = item.denominazione;
    this.customer.FR_Siren = item.siren;    
    this.customer.FR_Nic = item.nic;    
    this.customer.VatNumber = item.siren;    
    this.customer.FR_ComplementAddress= item.indirizzo?.complemento;
    this.customer.StreetNumber = item.indirizzo.numero;    
    this.customer.Street = [item.indirizzo?.tipo_via, item.indirizzo?.via].filter(Boolean).join(' ');    
    this.customer.PostalCode = item.indirizzo.cap;
    this.customer.City = item.indirizzo.citta;
    this.customer.District = item.indirizzo.communeCode;
    this.customer.Country = item.indirizzo.nazione;        
    let ct = new LookupDTO();
    ct.ID = 2;    
    ct.Label = "Entreprise";
    this.customer.CustomerType = ct;        
    let franceNation = new LookupDTO();
    franceNation.ID = item.indirizzo.stato;    
    franceNation.Label = "France";
    this.customer.Nation = franceNation;
    this.customer.Nation.ID = franceNation.ID;
  }


  onCarrierChange() {
    if (this.customer.IsCarrier == false) {
      this.customer.CarrierDrivingLicenseNumber = "";
      this.customer.CarrierEORICode = "";
      this.customer.CarrierTitle = "";

    }
  }

  checkDataValidation(): Array<string> {

    let errorText: Array<string> = new Array<string>();

    //Controllo che il codice fiscale sia valido (secondo validazione richiesta)
    if (this.customer != null && this.customer.FiscalCode != null && this.customer.FiscalCode != "") {
      let isValid = this.customer.FiscalCode.length >= 11 && this.customer.FiscalCode.length <= 16;
      if (isValid == false)
        errorText.push("Codice fiscale non valido");
    }

    //Controllo che il codice destinatario sia valido (secondo validazione richiesta)
    if (this.customer != null && this.customer.CodDestFE != null && this.customer.CodDestFE != "") {
      let isValid = this.customer.CodDestFE.length >= 6 && this.customer.CodDestFE.length <= 7;
      if (isValid == false)
        errorText.push("Codice destinatario non valido");
    }

    return errorText;
  }

  /**
   *
   */
  focusOutPec(event) {
    if (event != null && event.target != null && event.target.value != null && event.target.value != "") {
      if (this.customer.CodDestFE == null || this.customer.CodDestFE == "")
        this.customer.CodDestFE = "0000000";
    }
  }

  async loadSIRET() {
    if (this.customer.FR_Siren == null || this.customer.FR_Siren.length != 9) {
      DialogService.Error(this.translate.instant("GENERIC_LABEL.ENTER_VALID_SIREN"));
      return;
    }

    let results: any[] = [];         // la lista restituita dal servizio
    results = await this.customerService.InseefindByText(this.customer.FR_Siren,3);

    results.forEach(item => {
      let isNewic =  (this.tempestablishmentLines.find(x => x.FR_NIC == item.nic) == null) 
      
      if (isNewic) {
        this.establishmentLine = new StableOrganisationDTO();
      }
      else
      {
        this.establishmentLine = this.tempestablishmentLines.find(x => x.FR_NIC == item.nic);
      }
        
        this.establishmentLine.FR_NIC = item.nic;        
        this.establishmentLine.FR_ComplementAddress= item.indirizzo?.complemento;
        this.establishmentLine.StreetNumber = item.indirizzo.numero;
        this.establishmentLine.Address = [item.indirizzo?.tipo_via,, item.indirizzo?.via].filter(Boolean).join(' ');
        this.establishmentLine.PostalCode = item.indirizzo?.cap;
        this.establishmentLine.City = item.indirizzo?.citta;        
        this.establishmentLine.FK_Customer = this.customer.ID;      
        let franceNation = new LookupDTO();
        franceNation.ID = item.indirizzo.stato;    
        franceNation.Label = "France";
        this.establishmentLine.Nation = franceNation;
        this.establishmentLine.Nation.ID = franceNation.ID;

        if (isNewic) {
          this.tempestablishmentLines.push(this.establishmentLine);              
        }
    });

    this.establishmentLinesTable.reloadDatatable();

  }

  manageestablishmentLines(element = null) {
      
      if (element) {
        this.establishmentLine = { ...element };
        this.establishmentLineTitle = this.translate.instant('GENERIC_LABEL.ADD_STABLE_ORGANISATION');
        this.editLineIndex = (element as any).originalIndex;
      } else {
        this.establishmentLine = new StableOrganisationDTO();
        this.establishmentLineTitle = this.translate.instant('GENERIC_LABEL.ADD_STABLE_ORGANISATION');        
      }

      this.establishmentTemplateRef = this.dialog.open(this.establishmentTemplate, {
        disableClose: false,
        hasBackdrop: true,
        minHeight: '30%',
        minWidth: '40%',
        panelClass: 'contains-lookup'
      });

      this.establishmentTemplateRef.afterClosed().subscribe(() => {
        // usa l’optional chaining per evitare errori se il form non è inizializzato
        this.establishmentLineForm?.reset?.();
      });
    }

    savedStableOrganisation(event: StableOrganisationDTO) {
    
      if (event !== null && event !== undefined) {
        this.confirmestablishmentLine(event);          
      }
      this.closeestablishmentLines();        
      
  }

  
    //Aggiungo all'elenco il PaymentConditionLine
    confirmestablishmentLine(element: StableOrganisationDTO) {
        
  
      this.establishmentLine = element;
        
      if (this.editLineIndex == null) {      
        this.tempestablishmentLines.push(this.establishmentLine);      
       } else {
  
         this.tempestablishmentLines[this.editLineIndex] = this.establishmentLine;
       }
  
      this.establishmentLinesTable.reloadDatatable();
            
    }
  
    //Chiudo la modale reimpostando la proprietà iniziale delle Line
    closeestablishmentLines() {
      // this.paymentConditionLine = new PaymentConditionLinesDTO();
      this.editLineIndex = null;
      this.establishmentTemplateRef.close();
    }

    deleteestablishmentLine(element) {
        DialogService.Confirm(this.translate.instant("DIALOGS.DELETE_CONFIRM"), () => {
          let idcustomer = element.FK_Customer;
          if (element.ID == null) 
          {
            const index = this.tempestablishmentLines.indexOf(element);
            if (index > -1) {
              this.tempestablishmentLines.splice(index, 1);
              this.establishmentLinesTable.reloadDatatable();
            }
          } 
          else
          { 
            this.stableOrganisationService.delete(element.ID).then(() => {
                DialogService.Success(this.translate.instant("DIALOGS.DELETE_SUCCESS"));
                this.stableOrganisationService.getListByCustomerID(idcustomer).subscribe({
                  next: res => this.tempestablishmentLines = res,    
                });
              this.establishmentLinesTable.reloadDatatable();              
            });
          }          
        }, true);
      }

    configureColumns() {
        this.columns = [
          {
            key: "action", display: "",
            type: TypeColumn.MenuAction, buttonMenuIcon: "more_vert",
            styles: { flex: "0 0 6%" },
            actions: [
              {
                name: this.translate.instant("GENERIC_LABEL.EDIT"),
                icon: "edit",
                fn: (element) => this.manageestablishmentLines(element)
              },
              {
                name: this.translate.instant("GENERIC_LABEL.DELETE"),
                icon: "delete",
                fn: (element) => this.deleteestablishmentLine(element),
              }
            ]
          },
          { key: "FR_NIC", display: "NIC" , styles: { flex: '0 0 7%' }},
          //{ key: "Address", display: this.translate.instant("GENERIC_FIELDS.ADDRESS") , styles: { flex: '0 0 50%' }},          
          { key: "Address", display: this.translate.instant("GENERIC_FIELDS.ADDRESS") , type: TypeColumn.ExternalTemplate, externalTemplate: this.establishmentAddress, styles: { flex: '0 0 50%' } }, 
          { key: "PostalCode", display: this.translate.instant("GENERIC_FIELDS.POSTALCODE"), styles: { flex: '0 0 7%' } },          
          { key: "City", display: this.translate.instant("GENERIC_FIELDS.CITY") , styles: { flex: '0 0 30%' }},
        ]
      }
    

}
